import ClosePage from '../pages/close.vue';
import DonePage from '../pages/done.vue';
import EditPage from '../pages/edit.vue';
import ErrorPage from '../pages/error.vue';
import ExpiredPage from '../pages/expired.vue';
import HomePage from '../pages/home.vue';
import NotePage from '../pages/note.vue';
import PermissionsPage from '../pages/permission.vue';
import RegisterPage from '../pages/register.vue';
import SharePage from '../pages/share.vue';
import TCPage from '../pages/tc.vue';
import VideoPage from '../pages/video.vue';

import { getCurrentInstance } from "vue";
import { getDevice } from 'framework7';

var v_national_id;

var routes = [
  {
    path: '/',
    redirect({app, to, from, resolve, reject}) {
      var keycloak;
      try {
        keycloak=getCurrentInstance().appContext.config.globalProperties.$keycloak;
      } catch(error) {
        console.log("/ error, pass");
      }
      if(keycloak && keycloak.authenticated) {
        resolve('/edit');
      } else if(localStorage.token) {
        let known_token=localStorage.token;
        app.request({
          beforeSend: function (xhr) {
            xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          },
          method: 'post',
          url: '/v/status',
          data: {
            'token':localStorage.token
          },
          success: function (data, status, xhr) {
            localStorage.clear();
            if(data.pass) {
              localStorage.register_by_name=data.register_by_name;
              localStorage.token=data.token;
              switch(true) {
                case (data.progress==0):
                  localStorage.token=data.token;
                  resolve('/home');
                  break;
                case(data.progress==85):
                case(data.progress==90):
                  resolve('/done');
                  break;
                case(data.progress>=10):
                  // if(data.orientation) localStorage.orientation=data.orientation;
                  if(data.national_id) v_national_id=data.national_id;
                  resolve('/register');
                  break;
                default:
                  resolve('/home');
              }
            } else {
              resolve('/home');
            }
          },
          error: function (xhr, status, message) {
            resolve('/home');
          },
          dataType: 'json'
        });            
      } else {
        // default
        localStorage.clear();
        resolve('/home');
      }
    }
  },
  { 
    path: '/home', 
    async({app, to, from, resolve, reject}) {
      app.request({
        method: 'get',
        url: '/v/markdown/HOME',
        success: function(data, status, xhr) {
          resolve(
            { component: HomePage },
            { props: {markdown: data.text.HOME}}
          );
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { 
    path: '/note', 
    async({app, to, from, resolve, reject}) {
      app.request({
        method: 'get',
        url: '/v/markdown/NI',
        success: function(data, status, xhr) {
          let valid_from = (new Date(data.valid_from)).toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' });
          resolve(
            { component: NotePage },
            { props: {markdown: data.text.NI, valid_from: valid_from}},
          );
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { 
    path: '/register', 
    async({app, to, from, resolve, reject}) {
      app.request({
        method: 'get',
        url: '/v/markdown/IDCARD+OTP+ROTATION+SELFIE+VIDEO',
        success: function(data, status, xhr) {
          resolve(
            { component: RegisterPage },
            { props: {
              markdown_idcard: data.text.IDCARD,
              markdown_otp: data.text.OTP,
              markdown_rotation: data.text.ROTATION,
              markdown_selfie: data.text.SELFIE,
              markdown_video: data.text.VIDEO,
              national_id_keycloak: v_national_id,
            }}
          );
        },
        error: function(xhr, status, message) {
          if(status==500) 
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { 
    path: '/tc', 
    async({app, to, from, resolve, reject}) {
      app.request({
        method: 'get',
        url: '/v/markdown/TC',
        success: function(data, status, xhr) {
          let valid_from = (new Date(data.valid_from)).toLocaleString('ro-RO', { year: 'numeric', month: 'long', day: 'numeric' });
          resolve(
            { component: TCPage }, 
            { props: { markdown: data.text.TC, valid_from: valid_from, }, }
          );
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { path: '/done', component: DonePage, },
  { path: '/edit', 
    async({app, to, from, resolve, reject}) {
      const keycloak=getCurrentInstance().appContext.config.globalProperties.$keycloak;
      app.request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
          xhr.setRequestHeader('Authorization','Bearer '+ keycloak.token);
        },
        method: 'post',
        url: '/v/find',
        data: {},
        success: function(data, status, xhr) {
          resolve(
            { component: EditPage }, 
            { props: { person: data, }, }
          );
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { path: '/error', component: ErrorPage, },
  { path: '/reset', component: HomePage, },
  { path: '/share', component: SharePage, },
  { path: '/video', 
    async({app, to, from, resolve, reject}) {
      app.request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        method: 'post',
        url: '/v/video_setup',
        success: function(data, status, xhr) {
          resolve(
            { component: VideoPage },
            { props: { pin: data.pin }}
          );
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { 
    path: '/permission', 
    async({app, to, from, resolve, reject}) {
      app.request({
        method: 'get',
        url: '/v/markdown/VIDEO_PERMISSION',
        success: function(data, status, xhr) {
          resolve(
            { component: PermissionsPage },
            { props: { markdown: data.text.VIDEO_PERMISSION}}
          );
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { 
    path: '/homing/:token', 
    async({app, to, from, resolve, reject}) {
      let token = to.params.token;
      app.request({
        method: 'get',
        url: '/v/homing/'+token,
        data: {},
        success: function(data, status, xhr) {
          localStorage.clear();
          window.location.href=data.redirect_to;
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { 
    path: '/cancel', 
    async({app, to, from, resolve, reject}) {
      app.request({
        beforeSend: function (xhr) {
          xhr.setRequestHeader ('X-CSRF-TOKEN', localStorage.token);
        },
        method: 'post',
        url: '/v/cancel',
        data: {},
        success: function(data, status, xhr) {
          localStorage.clear();
          if(data.local_redirect==1) 
            resolve({
              component: ClosePage,
            });
          else
            window.location.href=data.redirect_to;
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
          if(status==419)
            resolve({
              componentUrl: '/expired',
            });
        },
        dataType: 'json'
      });
    },
  },
  { 
    path: '/expired', 
    async({app, to, from, resolve, reject}) {
      var uri;
      if(localStorage.token)
        uri = '/v/expired/'+localStorage.token;
      else
        uri = '/v/expired';
      localStorage.clear();
      app.request({
        method: 'get',
        url: uri,
        success: function(data, status, xhr) {
          resolve(
            { component: ExpiredPage },
            { props: { markdown: data.markdown, local_redirect: data.local_redirect || 1, redirect_uri: data.redirect_uri || '/'}}
          );
        },
        error: function(xhr, status, message) {
          if(status==500)
            resolve({
              component: ErrorPage,
            });
        },
        dataType: 'json'
      });
    },
  },
];

export default routes;
